<!--
 * @Author: 71
 * @Date: 2026-06-18
 * @Description: 学生会员订单弹窗
 * @FilePath: \aigoes-school-web\src\views\school\AppPage\ HundredDayOath\compoents\model\StudentMembershipModal.vue
-->
<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="tenantId"
          label="学校"
        >
          <a-select
            v-model="model.tenantId"
            placeholder="请选择学校"
            :disabled="editMode"
          >
            <a-select-option v-for="item in tenantList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="gradeId"
          label="年级"
        >
          <a-select
            v-model="model.gradeId"
            placeholder="请选择年级"
            :disabled="editMode"
          >
            <a-select-option v-for="item in gradeList" :key="item.id" :value="item.id">
              {{ item.gradeName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="classId"
          label="班级"
        >
          <a-select
            v-model="model.classId"
            placeholder="请选择班级"
            :disabled="editMode"
          >
            <a-select-option v-for="item in classList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="studentName"
          label="学生姓名"
        >
          <a-input placeholder="请输入学生姓名" v-model="model.studentName" :disabled="editMode" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="phone"
          label="手机号"
        >
          <a-input placeholder="请输入手机号" v-model="model.phone" :disabled="editMode" />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="openTime"
          label="会员开始日期"
        >
          <a-date-picker
            v-model="model.openTime"
            @change="(date, dateString) => handleDateChange('openTime', date, dateString)"
            placeholder="请选择会员开始日期"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="expireTime"
          label="会员到期日期"
        >
          <a-date-picker
            v-model="model.expireTime"
            @change="(date, dateString) => handleDateChange('expireTime', date, dateString)"
            placeholder="请选择会员到期日期"
            style="width: 100%"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'

export default {
  name: 'StudentMembershipModal',
  components: {},
  data() {
    return {
      editMode: false,
      title: '操作',
      visible: false,
      tenantList: [],
      gradeList: [],
      classList: [],
      model: {
        studentId: '',
        tenantId: '',
        gradeId: '',
        classId: '',
        studentName: '',
        phone: '',
        openTime: '', // validityStartTime
        expireTime: '', // validityEndTime
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },

      confirmLoading: false,
      validatorRules: {
        // tenantId: [{ required: true, message: '请选择学校!' }],
        // gradeId: [{ required: true, message: '请选择年级!' }],
        // classId: [{ required: true, message: '请选择班级!' }],
        // studentName: [{ required: true, message: '请输入学生姓名!' }],
        // phone: [{ required: true, message: '请输入手机号!' }],
        openTime: [{ required: true, message: '请选择会员开始日期!' }],
        expireTime: [{ required: true, message: '请选择会员到期日期!' }],
      },
      url: {
        edit: '/parentalAppStudentFunction/updateStudentFunction',
      },
    }
  },
  created() {},
  methods: {
    edit(record) {
      this.model = Object.assign({}, record)
      // 接口返回的字段名是 validityStartTime/validityEndTime，映射到弹窗的 openTime/expireTime
      if (record.validityStartTime) {
        this.model.openTime = record.validityStartTime
      }
      if (record.validityEndTime) {
        this.model.expireTime = record.validityEndTime
      }
      // 因为Ant Design Vue 的 a-select 组件使用严格相等，所以需要转换
      if (this.model.tenantId !== undefined && this.model.tenantId !== null) {
        this.model.tenantId = Number(this.model.tenantId)
      }
      if (this.model.gradeId !== undefined && this.model.gradeId !== null) {
        this.model.gradeId = this.model.gradeId
      }
      if (this.model.classId !== undefined && this.model.classId !== null) {
        this.model.classId = this.model.classId
      }
      this.editMode = true
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (this.model.studentId) {
            httpurl += this.url.edit
            method = 'post'
          }
          console.log(this.model)
          const params = {
            studentId: this.model.studentId,
            openTime: this.model.openTime ? this.formatDate(this.model.openTime) : '',
            expireTime: this.model.expireTime ? this.formatDate(this.model.expireTime) : '',
          }
          httpAction(httpurl, params, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleDateChange(field, date, dateString) {
      this.model[field] = dateString;
      this.$forceUpdate();
      // this.$set(this.model, field, dateString);
    },
    formatDate(date) {
      if (!date) return ''
      if (date instanceof Date) {
        return date.toISOString().slice(0, 10)
      }
      if (typeof date === 'string') {
        return date.slice(0, 10)
      }
      if (date.format) {
        return date.format('YYYY-MM-DD')
      }
      return String(date).slice(0, 10)
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
</style>